import React from 'react';

const ErrorPage = () => {
    return (
        <>
            <h1>ErrorPage</h1>
        </>
    )
}

export default ErrorPage;